module.exports = __webpack_public_path__ + "static/media/video.94dcb0d8.svg";